import { render, staticRenderFns } from "./AutomationWizardOverviewDescription.vue?vue&type=template&id=44670564&scoped=true&"
import script from "./AutomationWizardOverviewDescription.vue?vue&type=script&lang=js&"
export * from "./AutomationWizardOverviewDescription.vue?vue&type=script&lang=js&"
import style0 from "./AutomationWizardOverviewDescription.vue?vue&type=style&index=0&id=44670564&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44670564",
  null
  
)

export default component.exports